export var GhostModeAction;
(function (GhostModeAction) {
    GhostModeAction["OBSERVE"] = "observe";
    GhostModeAction["INJECT_ANSWER"] = "inject_answer";
    GhostModeAction["OVERRIDE_RESPONSE"] = "override_response";
    GhostModeAction["TAKEOVER"] = "takeover";
    GhostModeAction["RELEASE"] = "release";
    GhostModeAction["APPROVE"] = "approve";
    GhostModeAction["REJECT"] = "reject";
})(GhostModeAction || (GhostModeAction = {}));
// WebSocket event types for Ghost Mode real-time sync
export var GhostWsEvent;
(function (GhostWsEvent) {
    GhostWsEvent["JOIN"] = "ghost:join";
    GhostWsEvent["LEAVE"] = "ghost:leave";
    GhostWsEvent["TRANSCRIPT_UPDATE"] = "ghost:transcript";
    GhostWsEvent["PENDING_RESPONSE"] = "ghost:pending";
    GhostWsEvent["INJECT"] = "ghost:inject";
    GhostWsEvent["OVERRIDE"] = "ghost:override";
    GhostWsEvent["TAKEOVER"] = "ghost:takeover";
    GhostWsEvent["RELEASE"] = "ghost:release";
    GhostWsEvent["APPROVE"] = "ghost:approve";
    GhostWsEvent["REJECT"] = "ghost:reject";
    GhostWsEvent["OPERATOR_JOINED"] = "ghost:operator_joined";
    GhostWsEvent["OPERATOR_LEFT"] = "ghost:operator_left";
})(GhostWsEvent || (GhostWsEvent = {}));
//# sourceMappingURL=ghost-mode.js.map